"use client";
import React from "react";
import { testimoniosDe, verCaptura } from "@/lib/testimonios";

// Grilla de testimonios reales (mensajes privados de Instagram).
//
// El texto va en HTML, NO solamente en la captura. Antes esta sección eran 4 PNG
// con el texto quemado adentro: Google no lo leía, una IA no lo podía citar, un
// lector de pantalla tampoco, y en un celular una imagen de 520px de ancho se
// lee mal. La captura queda como prueba, a un click, pero el contenido es texto.
//
// Van sin nombre porque ninguna de las 28 capturas muestra uno. No inventar
// nombres: sin autor real no se puede emitir Review en JSON-LD, y firmar con una
// persona inexistente sería una reseña falsa.
export default function Testimonials({ locale, title, onZoom, isWide, background = "#f8f8f8" }) {
  const items = testimoniosDe(locale);
  const verLabel = verCaptura(locale);
  if (!items.length) return null;

  return (
    <section style={{ background, padding: "60px 20px" }}>
      <div style={{ maxWidth: 700, margin: "0 auto" }}>
        {title && (
          <h2 style={{ fontSize: 26, fontWeight: 700, color: "#111", textAlign: "center", marginBottom: 36 }}>{title}</h2>
        )}
        {/* stretch y no start: en dos columnas las tarjetas de una misma fila
            quedan del mismo alto y la grilla no se ve rota.
            Con una sola cita se fuerza una columna aunque haya lugar para dos:
            pasa en /es|/en|/ja/libro/glue, donde el filtro por libro deja un solo
            mensaje, y en desktop la tarjeta ocupaba media pantalla con la mitad
            derecha vacía debajo de un título centrado, que se lee como un error
            de carga y no como un testimonio. */}
        <div style={{ display: "grid", gridTemplateColumns: isWide && items.length > 1 ? "1fr 1fr" : "1fr", gap: 16, alignItems: "stretch" }}>
          {items.map((t, i) => (
            <figure
              key={i}
              style={{
                margin: 0,
                background: "#fff",
                borderRadius: 12,
                padding: "18px 20px 14px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <blockquote style={{ margin: 0, fontSize: 15, lineHeight: 1.6, color: "#333", flex: 1 }}>
                {t.texto}
              </blockquote>
              <figcaption style={{ marginTop: 12, fontSize: 12, color: "#767676" }}>
                {onZoom && (
                  <button
                    type="button"
                    onClick={() => onZoom(t.img)}
                    style={{
                      background: "none",
                      border: "none",
                      padding: 0,
                      cursor: "pointer",
                      font: "inherit",
                      color: "#767676",
                      textDecoration: "underline",
                      textUnderlineOffset: 3,
                    }}
                  >
                    {t.verOriginal || verLabel}
                  </button>
                )}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
